/* eslint-disable @typescript-eslint/naming-convention */
import { LocationId, Page } from '@fmnts/api';
import {
  GetNextLocationListQuery,
  IApiNextLocationCheckInCreateDto,
  NextLocation,
  NextLocationCheckIn,
} from '@fmnts/api/next';
import {
  createHttpActions,
  createHttpUploadActions,
} from '@fmnts/common/store';
import { GeneralHttpError } from '@formunauts/shared/errors/domain';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LocationCheckIn } from './next-location.types';
import { LocationOfflineStored } from './next-locations.reducer';

enum NextLocationActionSource {
  Api = 'Next Location API',
  Init = 'Next Location Init',
  ListPage = 'Next Location List Page',
  DetailPage = 'Next Location Detail Page',
  Offline = 'Next Location Offline',
}

export const NextLocationDetailPageActions = createActionGroup({
  source: NextLocationActionSource.DetailPage,
  events: {
    enter: emptyProps(),
    'Check In': props<LocationCheckIn>(),
  },
});
export const NextLocationListPageActions = createActionGroup({
  source: NextLocationActionSource.ListPage,
  events: {
    enter: emptyProps(),
    'Check In': props<LocationCheckIn>(),
    Reset: emptyProps(),
  },
});

export const NextLocationInitActions = createActionGroup({
  source: NextLocationActionSource.Init,
  events: {
    Hydrate: props<LocationCheckIn>(),
  },
});

const NextLocationApiGetActions = createHttpActions(
  NextLocationActionSource.Api,
  'Get Location',
  {
    request: props<{ locationId: LocationId }>(),
    success: props<{ payload: NextLocation }>(),
    failure: props<{ error: GeneralHttpError }>(),
  },
);

const NextLocationApiGetListAllActions = createHttpActions(
  NextLocationActionSource.Api,
  'Get Location List All',
  {
    request: props<{ query: GetNextLocationListQuery }>(),
    success: props<{ payload: NextLocation[] }>(),
    failure: props<{ error: GeneralHttpError }>(),
  },
);

const NextLocationApiGetListActions = createHttpActions(
  NextLocationActionSource.Api,
  'Get Location List',
  {
    request: props<{ query: GetNextLocationListQuery }>(),
    success: props<{ payload: Page<NextLocation> }>(),
    failure: props<{ error: GeneralHttpError }>(),
  },
);

const NextLocationApiCheckInActions = createHttpActions(
  NextLocationActionSource.Api,
  'Check in Location',
  {
    request: props<{ checkIn: IApiNextLocationCheckInCreateDto }>(),
    success: props<{ payload: NextLocationCheckIn }>(),
    failure: props<{
      error: GeneralHttpError;
      checkIn: IApiNextLocationCheckInCreateDto;
    }>(),
  },
);

export const NextLocationApiActions = {
  getLocation: NextLocationApiGetActions,
  getLocationList: NextLocationApiGetListActions,
  getLocationListAll: NextLocationApiGetListAllActions,
  checkIn: NextLocationApiCheckInActions,
};

export const NextLocationCheckInOfflineActions = createActionGroup({
  source: NextLocationActionSource.Offline,
  events: {
    persist: props<{
      checkIn: IApiNextLocationCheckInCreateDto;
    }>(),
    hydrate: props<{
      locations: LocationOfflineStored[];
    }>(),
    remove: props<{ dataKey: string }>(),
  },
});

export const NextLocationCheckInOfflineUploadActions = createHttpUploadActions(
  NextLocationActionSource.Offline,
  'Upload offline-stored Check in',
  {
    request: props<{
      dataKey: string;
      inBackground: boolean;
      payload: IApiNextLocationCheckInCreateDto;
    }>(),
    success: props<{
      response: {
        payload: IApiNextLocationCheckInCreateDto;
        dataKey: string;
        inBackground: boolean;
      };
    }>(),
    failure: props<{
      dataKey: string;
      error: GeneralHttpError;
      inBackground: boolean;
    }>(),
  },
);
